import { type AnalyticsEventPayload } from '@atlaskit/analytics-next';

export const MESSAGE_ID = 'INAPP-3282';

export const PRIMARY_ACTION_DATA_URL = 'https://www.atlassian.com/software/confluence/pricing';

export const TRIGGER: AnalyticsEventPayload = {
	context: {},
	data: {
		action: 'viewed',
		actionSubject: 'home',
		attributes: {
			navdexPointType: 'navigationSessionStartTouch',
		},
		source: 'homeScreen',
	},
	type: 'sendTrackEvent',
};

// this data comes from atlas personalization engagement messages find --include-all-fields --output-format=json
// EP Message Metadata for posterity.
// {
// 	ArchivedDate: null,
// 	Audience: 'SITE_USER',
// 	Category: 'ENGAGEMENT',
// 	CreatedByUserID: 'jgandhi',
// 	CreatedDate: '2025-02-07T23:19:03.717905Z',
// 	Description: '',
// 	DuplicateCheckRequired: false,
// 	Events: [],
// 	Expiry: 5,
// 	FatiguePeriod: 0,
// 	FeatureFlag: '',
// 	Hypothesis:
// 		'We believe if we notify users their upgrade has failed during onboarding, then more users will upgrade their confluence edition to the desired edition',
// 	MessageGroup: 'CROSS_FLOW',
// 	MessageID: 'INAPP-3282',
// 	MessageSource: 'TARGETINGPLATFORM',
// 	MessageStatus: 'ROLLOUT',
// 	MessageVariations: [
// 		{
// 			variationId: 'a',
// 			metadata: {
// 				components: [
// 					{
// 						body: 'We’ve kept you on the Standard plan of Confluence for now.',
// 						componentType: 'flag',
// 						icon: 'info',
// 						primaryAction: {
// 							appearance: 'primary',
// 							data: {
// 								target: '_blank',
// 								url: 'https://www.atlassian.com/software/confluence/pricing',
// 							},
// 							type: 'link',
// 						},
// 						primaryText: 'Upgrade options',
// 						secondaryAction: {
// 							appearance: 'default',
// 							type: 'dismiss',
// 						},
// 						secondaryText: 'Dismiss',
// 						title: 'We’re having trouble with your plan',
// 						triggers: [
// 							{
// 								context: {},
// 								data: {
// 									action: 'viewed',
// 									actionSubject: 'home',
// 									attributes: {
// 										navdexPointType: 'navigationSessionStartTouch',
// 									},
// 									source: 'homeScreen',
// 								},
// 								type: 'sendTrackEvent',
// 							},
// 						],
// 					},
// 				],
// 				messageId: 'INAPP-3282',
// 				variationId: 'a',
// 			},
// 			enabled: true,
// 			schemaVersion: '2',
// 			maxTriggers: 5000,
// 			pValue: 0,
// 			triggerCount: 0,
// 			previewUrl: '',
// 			lastSentTime: null,
// 		},
// 	],
// 	MetricType: 'NONE',
// 	NotificationID: '',
// 	OverrideHoldout: false,
// 	Owner: 'jgandhi',
// 	PausedDate: null,
// 	Platform: 'WEB',
// 	PreAnalysisAudience: 0,
// 	Product: 'confluence',
// 	ProductionizedDate: null,
// 	ReportingDate: null,
// 	RolloutDate: '2025-02-18T18:57:10.719357Z',
// 	RolloutRate: 1,
// 	SegmentID: 'auto_provisioning_experiment_upgrade_error_confluence_edition_standard_siteuser',
// 	SuccessEventAttributionWindowDays: 7,
// 	Summary: 'auto-provisioning-experiment-upgrade-edition-failure-flag-standard-confluence',
// 	TargetProduct: 'confluence',
// 	Type: 'IN_PRODUCT',
// }
